import { store } from '../index';

export const API_ACTION_MACHINESBYMACHINETYPE = "Machine/GetByMachineTypeId";
export const API_ACTION_RESTARTSCALE = "Machine/RestartScale";
export const API_ACTION_RESTARTRECYCLESCALE = "Machine/RestartRecycleScale";
export const API_ACTION_MACHINESWITHSCISSORSTATUSINFO = "Machine/GetMachinesWithScissorStatusInfo";
export const API_ACTION_PRODUCTIONORDERSBYMACHINE = "ProductionOrder/GetByMachineId";
export const API_ACTION_GETALLPRODUCTIONORDERSBYMACHINE = "ProductionOrder/GetAllByMachineId";
export const API_ACTION_GETPRODUCTIONORDERSIDLIST = "ProductionOrder/GetAllProductionOrdersByIdList";
export const API_ACTION_PRODUCTIONORDERSBYCARPENTRYMACHINE = "ProductionOrder/GetByCarpentryMachineId";
export const API_ACTION_PRODUCTIONORDERSBYSEARCHTEXT = "ProductionOrder/GetBySearchText";
export const API_ACTION_PRODUCTIONORDERSBYCARPENTRYSEARCHTEXT = "ProductionOrder/GetByCarpentrySearchText";
export const API_ACTION_ORDERDETAILS = "ProductionOrder/GetOrderDetailsByOrderId";
export const API_ACTION_SYTEMPARAMETER = "SystemParameter/";
export const API_ACTION_GETSYTEMPARAMETERSBYIDLIST = "SystemParameter/GetByIdList";
export const API_ACTION_ASSIGNQUANTITYATMACHINE = "MachineInAssignedLogic/AssignQuantityAtMachine";
export const API_ACTION_GETMACHINEINASSIGNEDBYMACHINEID = "MachineInAssigned/GetByMachineId";
export const API_ACTION_GETMACHINEBYCODE = "Machine/GetMachineByCode";
export const API_ACTION_DELETEMACHINEINASSIGNEDBYID = "MachineInAssigned/";
export const API_ACTION_UPDATEZONES = "ProductionOrderBOWLogic/UpdateZones";
export const API_ACTION_STARTPRODUCTIONORDER = "ProductionOrderLogic/StartProductionOrder";
export const API_ACTION_PAUSEPRODUCTIONORDER = "ProductionOrderLogic/PauseProductionOrder";
export const API_ACTION_STOPPRODUCTIONORDER = "ProductionOrderLogic/StopProductionOrder";
export const API_ACTION_FINISHPRODUCTIONORDER = "ProductionOrderLogic/FinishProductionOrder";
export const API_ACTION_GETPRODUCTIONORDERLINEBOMOUTPRODUCED = "ProductionOrderLineBOMOutProduced/GetByBOMOutId";
export const API_ACTION_CREATEBOOKING = "ProductionOrderLogic/CreateBookingForProductionOrder"
export const API_ACTION_GETMACHINESETTINGSBYMACHINEID = "MachineSetting/GetMachineSettingsByMachineId";
export const API_ACTION_SAVEMACHINESETTINGS = "MachineSettingLogic/SaveMachineSettings";
export const API_ACTION_GETQUALITYSAMPLESBYBARCODE = "QualitySampleLogic/GetQualitySamplesByBarcode";
export const API_ACTION_SAVEQUALITYSAMPLES = "QualitySampleLogic/SaveQualitySamples";
export const API_ACTION_GETQUALITYSAMPLESBYPRODUCTIONORDER = "QualitySampleLogic/GetQualitySampleValuesByProductionOrderId";
export const API_ACTION_MACHINESTOPPEDREASON = "Machine/MachineStoppedReason";
export const API_ACTION_SAVENOTIFICATION = "Notification/";
export const API_ACTION_GETLATESTNOTIFICATIONS = "NotificationLogic/GetLatestNotifications";
export const API_ACTION_GETCHECKNUMBERFORPALLET = "QualitySampleValue/GetCheckNumberForPallet";
export const API_ACTION_GETBOOKINGSEQUENCE = "QualitySampleLogic/GetBookingSequenceByProductionOrderIdAndBarcode";
export const API_ACTION_GETLASTWEIGHT = "Scale/";
export const API_ACTION_VALIDATEANDHASROLE = "User/ValidateAndHasRole";
export const API_ACTION_GETARTICLEINFOBYBARCODE = "MachineInAssignedLogic/GetArticleInfoByBarcode";
export const API_ACTION_MACHINEREASONKNOWN_NODE_RED = "machineReasonKnown"
export const API_ACTION_SAVE_OPC_NOTIFICATION = "saveOpcNotification"
export const API_ACTION_ORDERLINEHISTORY = "ProductionOrderLogic/GetOrderLineStateHistory";
export const API_ACTION_GETALLUSERSWITHDETAILS = "User/GetAllUsersWithDetails";
export const API_ACTION_SAVEUSER = "UserLogic/SaveUser";
export const API_ACTION_GETALLROLES = "Role";
export const API_ACTION_RESYNCORDERS = "ProductionOrder/ResyncOrders";
export const API_ACTION_GETZONEDIVISIONS = "ZoneDivision/GetZoneDivisionsForOrderLine";
export const API_ACTION_SAVEZONEDIVISIONS = "ZoneDivision/SaveZoneDivisionsForOrderLine";
export const API_ACTION_GETWEIGHTFORLINENUMBER = "Scale/GetForLineNumber";
export const API_ACTION_GETWEIGHTFORRECYCLE = "Scale/GetForRecyclingScale";
export const API_ACTION_SWITCHRAWMATERIAL = "ProductionOrder/SwitchRawMaterial";
export const API_ACTION_GETORIGINALRAWMATERIALBOMS = "ProductionOrder/GetOriginalRawMaterialBoms";
export const API_ACTION_GETISBOOKINGCRITICAL = "ProductionOrder/GetIsBookingCritical";
export const API_ACTION_LOGSTANDSTILLSTART = "ProductionOrder/LogStandstillStart";
export const API_ACTION_LOGSTANDSTILLSTOP = "ProductionOrder/LogStandstillStop";
export const API_ACTION_GETPRODUCTIONSTATEBYMACHINEID = "Machine/GetProductionStateByMachine";
export const API_ACTION_GETSTOPREASONS = "ProductionOrderLogic/GetStopReasons";
export const API_ACTION_UPDATEPRODUCTIONORDERSTATUSLOG = "ProductionStateLog";
export const API_ACTION_GETSCRAPCOLORS = "Product/GetScrapColors";
export const API_ACTION_GETSCRAPCARRIERTYPES = "Carrier/GetScrapCarrierTypes";
export const API_ACTION_GETSCRAPMATERIALTYPES = "MaterialType/GetScrapMaterialTypes";
export const API_ACTION_GETRECYCLINGHISTORY = "RecyclingHistory/GetRecyclingHistory";
export const API_ACTION_POSTRECYCLINGHISTORYENTRY = "RecyclingHistory/PostRecyclingHistoryEntry";
export const API_ACTION_CARRIEREXISTS = "Carrier/CarrierExists";
export const API_ACTION_GETWASTELOCATIONS = "WasteLocation/GetAllWasteLocations";
export const API_ACTION_ADDOPERATORCOMMENT = "ProductionOrderLogic/AddOperatorComment";
export const API_ACTION_GETOPERATORCOMMENTS = "ProductionOrderLogic/GetOperatorComments";

export default class ApiHelper {
    static appSettings;
}

export const ComposeUri = (action) => {

    return ApiHelper.appSettings.IPB_SHOPFLOOR_API_BASE_URL + action;
}

export const ComposeInterfaceUri = (action) => {
    return ApiHelper.appSettings.IPB_INTERFACE_API_BASE_URL + action;
}

export const ComposeNodeRedUri = (action) => {
    return ApiHelper.appSettings.IPB_ORCHESTRATION_URL + action;
}

export const getAuthHeader = () => {
    var state = store.getState();
    var token = state.user.userToken;
    if (token === "" || token === null || token === undefined) {
        return localStorage.access_token ? 'Bearer ' + localStorage.access_token : '';
    } else {
        return token ? 'Bearer ' + token : '';

    }
}

